import { put, takeEvery } from 'redux-saga/effects';
import { AUTH_CH, AUTH_SET, AUTH_LOUT } from '../../constants';
import { authCh, authChData } from '../../actions';
import axios from 'axios';
import dlCommon from '../../dlCommon';

axios.defaults.withCredentials = true;

function* sgAuthSet(action) {
    let url;
    url = dlCommon.apiUrlGet('common', 'l-in');   
    yield axios.post(url, action.payload).then(res => res.data);
    yield put(authCh());        
}

function* sgAuthCh(action) {
    const itemId = action.payload;
    const url = dlCommon.apiUrlGet('common', 's-u');
    const uType = yield axios.get(url, { withCredentials: true }).then((res) => {
        // console.log('res');
        // console.log(res);        
        return res.data.uType;
    });    
    yield put(authChData(uType));
}

function* sgAuthLout(action) {
    const url = dlCommon.apiUrlGet('common', 'l-out');
    yield axios.get(url).then(res => res.data);
}

export function* actWatchAdmAuth() {
    yield takeEvery(AUTH_CH, sgAuthCh);
    yield takeEvery(AUTH_SET, sgAuthSet);
    yield takeEvery(AUTH_LOUT, sgAuthLout);
}

